var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.998v4.5H2M6 18.5a9.5 9.5 0 112.47 1.638",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDEzLjk5ODRWMTguNDk4NEgyIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuMDAwMDUgMTguNDk5NEM0LjIzODUxIDE2Ljg4MjggMy4xNTEyOCAxNC42NjE1IDIuOTU1MzIgMTIuMjc4N0MyLjc1OTM2IDkuODk1ODQgMy40NjkwNyA3LjUyNjc0IDQuOTQyODQgNS42NDQxMUM2LjQxNjYxIDMuNzYxNDggOC41NDYwNSAyLjUwMzc3IDEwLjkwNjIgMi4xMjE5NUMxMy4yNjY0IDEuNzQwMTQgMTUuNjgzOCAyLjI2MjI5IDE3LjY3NiAzLjU4NDIzQzE5LjY2ODIgNC45MDYxNyAyMS4wODg2IDYuOTMwNjYgMjEuNjU0IDkuMjUzNzRDMjIuMjE5MyAxMS41NzY4IDIxLjg4NzkgMTQuMDI3NiAyMC43MjU5IDE2LjExNzJDMTkuNTYzOSAxOC4yMDY3IDE3LjY1NjggMTkuNzgxMiAxNS4zODUgMjAuNTI2NkMxMy4xMTMzIDIxLjI3MTkgMTAuNjQ0MSAyMS4xMzMzIDguNDcwMDUgMjAuMTM4NCIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgRefresh as ReactComponent };